/* ========================================================================
   Videos
 ========================================================================== */

app.videos = (function () {
  'use strict';

  function init() {
    const videos = document.querySelectorAll('[data-video]');
    if (videos.length === 0) return;

    videos.forEach((video) => {
      initVideo(video);
    });

    document.addEventListener('cookieconsent_update', (event) => {
      if (typeof event.detail.grantedCategories !== 'object') return;

      if (event.detail.grantedCategories.indexOf('marketing') > -1) {
        removeConsentWarning();
      }
    });
  }

  function initVideo(video) {
    const preview = video.querySelector('[data-video-preview]');
    const button = video.querySelector('[data-video-button]');
    const iframe = video.querySelector('[data-video-iframe]');
    const videoUrl = button.getAttribute('href');

    button.addEventListener('click', (event) => {
      event.preventDefault();

      iframe.innerHTML = util.getVideoEmbedHtmlFromUrl(videoUrl);

      if (preview) preview.remove();
      button.remove();

      // DATALAYER
      app.dataLayer.pushEvent('videoBekeken', {
        pageUrl: window.location.pathname,
        title: button.dataset.videoTitle,
      });
    });
  }

  function removeConsentWarning() {
    const videos = document.querySelectorAll('[data-video]');
    if (videos.length === 0) return;

    videos.forEach((video) => {
      const button = video.querySelector('[data-video-button]');
      const consent = video.querySelector('[data-video-consent]');

      button.classList.remove('is-hidden');
      if (consent) consent.remove();
    });
  }

  // Expose public functions and variables
  return {
    init: init,
    removeConsentWarning: removeConsentWarning,
  };
})();
